import React, {useReducer} from 'react';

import SessionStateContext from '../context/SessionStateContext';
import DispatchContext from '../context/DispatchContext';
import {reducer} from '../../reducer';

const initialSessionState = {
  nav_history: [],
  timestamp: new Date(),
  serviceRequestUpdate: {},
  app_loading: false,
};

export let StaticDispatch = null;
export let StaticNavigation = null;
export let StaticState = null;

const storeReducer = (state, action) => {
  const newState = reducer(state, action);
  return newState;
};

export default (App) => {
  const WrappedApp = (props) => {
    const [sessionState, dispatch] = useReducer(
      storeReducer,
      initialSessionState,
    );

    StaticDispatch = dispatch;
    StaticState = sessionState;

    return (
      <SessionStateContext.Provider value={sessionState}>
        <DispatchContext.Provider value={dispatch}>
          <App {...props} />
        </DispatchContext.Provider>
      </SessionStateContext.Provider>
    );
  };

  return WrappedApp;
};
